import React from "react";
import { useTranslation } from "react-i18next";
import HeroGradeCard from "./HeroGradeCard";
import CriteriaList from "./CriteriaList";

const EvaluationPanel = ({ analysis, company_config, is_sider }) => {
  const { t } = useTranslation();
  const has_breakdown =
    Array.isArray(analysis?.items_breakdown) && analysis.items_breakdown.length > 0;

  return (
    <div className="flex flex-col gap-4">
      <HeroGradeCard analysis={analysis} />
      {has_breakdown && (
        <div>
          <div className="text-[10px] uppercase tracking-wide text-gray-500 font-semibold mb-2">
            {t("Critères")}
          </div>
          <CriteriaList
            analysis={analysis}
            company_config={company_config}
            is_sider={is_sider}
          />
        </div>
      )}
    </div>
  );
};

export default EvaluationPanel;
